import { useState } from 'react';
import { motion } from 'framer-motion';
import { Slider } from '../components/ui/slider';
import { Button } from '../components/ui/button';

const moodLabels = {
  1: 'Very Low',
  2: 'Low',
  3: 'Somewhat Low',
  4: 'Below Average',
  5: 'Neutral',
  6: 'Above Average',
  7: 'Good',
  8: 'Great',
  9: 'Excellent',
  10: 'Amazing'
};

const getMoodColor = (score) => {
  if (score <= 3) return '#D54B48';
  if (score <= 5) return '#F8B64C';
  if (score <= 7) return '#8BB89F';
  return '#C10891';
};

export function MoodSlider({ initialValue = 5, onSave, loading = false }) {
  const [value, setValue] = useState(initialValue);
  const color = getMoodColor(value);

  return (
    <div className="space-y-6">
      <div className="text-center">
        <motion.div
          key={value}
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          className="inline-flex items-center justify-center w-24 h-24 rounded-full mb-4"
          style={{ 
            backgroundColor: `${color}20`,
            border: `3px solid ${color}`,
            boxShadow: `0 0 30px ${color}40`
          }}
        >
          <span className="text-4xl font-bold font-heading" style={{ color }}>
            {value}
          </span>
        </motion.div>
        <motion.p
          key={`label-${value}`}
          initial={{ y: 10, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          className="text-lg font-medium"
          style={{ color }}
        >
          {moodLabels[value]}
        </motion.p>
      </div>

      <div className="px-4">
        <div className="relative">
          <div 
            className="absolute inset-0 h-2 rounded-full top-1/2 -translate-y-1/2"
            style={{
              background: `linear-gradient(to right, #D54B48 0%, #F8B64C 40%, #8BB89F 70%, #C10891 100%)`
            }}
          />
          <Slider
            value={[value]}
            onValueChange={([v]) => setValue(v)}
            min={1}
            max={10}
            step={1}
            className="relative z-10"
          />
        </div>
        <div className="flex justify-between mt-2 text-xs text-muted-foreground">
          <span>Low</span>
          <span>High</span>
        </div>
      </div>

      {onSave && (
        <Button
          onClick={() => onSave(value)}
          disabled={loading}
          className="w-full bg-primary hover:bg-primary/90 text-white rounded-full py-6"
          data-testid="save-mood-btn"
        >
          {loading ? 'Saving...' : 'Save Mood'}
        </Button>
      )}
    </div>
  );
}
